import axios from "axios";

const API_BASE = process.env.NEXT_PUBLIC_API_URL || "http://localhost:8000";

export const loginCollegeAdmin = async (email, password) => {
  const res = await axios.post(`${API_BASE}/clg-admin/login`, {
    email,
    password,
  });
  return res.data;
};

export const logoutCollegeAdmin = async () => {
  const res = await axios.post(`${API_BASE}/clg-admin/logout`);
  return res.data;
};

export const refreshCollegeAdminToken = async (refreshToken) => {
  const res = await axios.post(`${API_BASE}/clg-admin/refresh`, {
    refreshToken,
  });
  return res.data;
};

const clgAdminAPI = axios.create({
  baseURL: `${API_BASE}/clg-admin`,
  headers: {
    "Content-Type": "application/json",
  },
});

clgAdminAPI.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("collegeAdminToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

clgAdminAPI.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("collegeAdminToken");
      if (typeof window !== "undefined") {
        window.location.href = "/";
      }
    }
    return Promise.reject(error.response?.data || error.message);
  }
);

export const dashboardAPI = {
  getOverview: () => clgAdminAPI.get("/dashboard/overview"),
};

export const studentsAPI = {
  getAll: (params) => clgAdminAPI.get("/students", { params }),
  getAtRisk: (params) => clgAdminAPI.get("/students/at-risk", { params }),
};

export const analyticsAPI = {
  getSubjectWise: (params) =>
    clgAdminAPI.get("/analytics/subject-wise", { params }),
  getMonthly: (months = 6) =>
    clgAdminAPI.get("/analytics/monthly", { params: { months } }),
};

export default {
  auth: {
    login: loginCollegeAdmin,
    logout: logoutCollegeAdmin,
    refresh: refreshCollegeAdminToken,
  },
  dashboard: dashboardAPI,
  students: studentsAPI,
  analytics: analyticsAPI,
};
